// src/pages/Developer.js
// API & Webhooks (marchand / admin)
// Maxula

import React, { useEffect, useState } from 'react';
import { FiKey, FiTrash2, FiPlus, FiCopy, FiZap, FiSend } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { developerAPI } from '../services/api';

const Developer = () => {
  const [keys, setKeys] = useState([]);
  const [hooks, setHooks] = useState([]);
  const [newKey, setNewKey] = useState(null);
  const [hookUrl, setHookUrl] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const [k, w] = await Promise.all([developerAPI.listKeys(), developerAPI.listWebhooks()]);
      setKeys(k.data?.data || []);
      setHooks(w.data?.data || []);
    } catch (e) {} finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const createKey = async () => {
    try { const res = await developerAPI.createKey({ name: 'Clé API' }); setNewKey(res.data?.data?.key); toast.success('Clé créée'); load(); }
    catch (e) { toast.error('Erreur'); }
  };
  const revoke = async (id) => { if (!window.confirm('Révoquer cette clé ?')) return; try { await developerAPI.revokeKey(id); load(); } catch (e) { toast.error('Erreur'); } };
  const copy = (t) => { navigator.clipboard?.writeText(t); toast.success('Copié'); };

  const addHook = async () => {
    if (!hookUrl) return toast.error('URL requise');
    try { await developerAPI.createWebhook({ url: hookUrl, events: ['*'] }); setHookUrl(''); toast.success('Webhook ajouté'); load(); }
    catch (e) { toast.error('Erreur'); }
  };
  const delHook = async (id) => { try { await developerAPI.deleteWebhook(id); load(); } catch (e) {} };
  const testHook = async () => { try { await developerAPI.testWebhook(); toast.success('Événement test envoyé'); } catch (e) { toast.error('Erreur'); } };

  if (loading) return <div className="flex justify-center py-24"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" /></div>;

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">API & Webhooks</h1>

      {/* API KEYS */}
      <div className="bg-white rounded-xl border border-gray-200 p-5 mb-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-semibold flex items-center gap-2"><FiKey /> Clés API</h2>
          <button onClick={createKey} className="px-3 py-1.5 rounded-lg bg-primary-600 text-white text-sm flex items-center gap-1 hover:bg-primary-700"><FiPlus size={14} /> Nouvelle clé</button>
        </div>
        {newKey && (
          <div className="mb-3 p-3 rounded-lg bg-amber-50 border border-amber-200 text-sm">
            <div className="font-medium text-amber-800 mb-1">Copiez votre clé (affichée une seule fois) :</div>
            <div className="flex items-center gap-2">
              <code className="flex-1 break-all bg-white px-2 py-1 rounded border text-xs">{newKey}</code>
              <button onClick={() => copy(newKey)} className="p-2 text-primary-600 hover:bg-primary-50 rounded"><FiCopy size={14} /></button>
            </div>
          </div>
        )}
        {keys.length === 0 ? <div className="text-sm text-gray-400">Aucune clé.</div> : (
          <div className="divide-y divide-gray-100">
            {keys.map((k) => (
              <div key={k._id} className="py-2 flex items-center justify-between">
                <div><div className="font-medium text-sm">{k.name}</div><div className="text-xs text-gray-400">{k.prefix}••• · {new Date(k.createdAt).toLocaleDateString('fr-FR')}</div></div>
                <button onClick={() => revoke(k._id)} className="p-2 text-red-600 hover:bg-red-50 rounded"><FiTrash2 size={14} /></button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* WEBHOOKS */}
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-semibold flex items-center gap-2"><FiZap /> Webhooks</h2>
          <button onClick={testHook} className="px-3 py-1.5 rounded-lg border text-sm flex items-center gap-1 hover:bg-gray-50"><FiSend size={14} /> Tester</button>
        </div>
        <div className="flex gap-2 mb-3">
          <input value={hookUrl} onChange={(e) => setHookUrl(e.target.value)} placeholder="https://votre-domaine.com/webhook" className="flex-1 border rounded-lg px-3 py-2" />
          <button onClick={addHook} className="px-4 py-2 rounded-lg bg-primary-600 text-white hover:bg-primary-700"><FiPlus size={16} /></button>
        </div>
        <p className="text-xs text-gray-400 mb-3">Événements: deal.created, subscription.activated, test.ping (signature HMAC dans l'en-tête X-Signature).</p>
        {hooks.length === 0 ? <div className="text-sm text-gray-400">Aucun webhook.</div> : (
          <div className="divide-y divide-gray-100">
            {hooks.map((h) => (
              <div key={h._id} className="py-2 flex items-center justify-between">
                <div className="min-w-0"><div className="font-medium text-sm truncate">{h.url}</div><div className="text-xs text-gray-400">{(h.events || []).join(', ')} · {h.lastStatus || 'jamais déclenché'}</div></div>
                <button onClick={() => delHook(h._id)} className="p-2 text-red-600 hover:bg-red-50 rounded"><FiTrash2 size={14} /></button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Developer;
